import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';

import MoonLoader from 'react-spinners/ClipLoader';
import {
  showModal,
  setActiveWidget,
  setBaggageBasket,
  setBaggageData,
} from '../../redux/actions.js';
import BaggageIcon from '../baggage/BaggageIcon';
import { FormattedMessage } from 'react-intl';
import { parseAcceptedBags } from '../../utils/parseAcceptedBags';
import UpsellSummary from '../shared/UpsellSumary';
import { getBaggageTriggerTitle } from '../../utils/trigger';
import { getTriggerStyles, getTriggerButtonStyles } from '../../themes/utils';

const Trigger = ({
  baggageData,
  showModal,
  setActiveWidget,
  hasBags,
  setBaggageBasket,
  basket,
  variants,
  theme,
  textOverrides,
}) => {
  const [removeButtonClicked, setRemoveButtonClicked] = useState(false);
  const availableBags = Boolean(baggageData?.results?.products?.bag);
  const amountOfSelectedBags = Object.values(basket.bags)
    .flatMap((p) =>
      Object.values(p).map((b) =>
        b.bagType === 'weight_system' ? 1 : b.quantity
      )
    )
    .reduce((totalBags, quantity) => totalBags + quantity, 0);

  const showRemoveButton =
    (typeof variants?.test_clear_baggage_basket_button === 'string' &&
      variants?.test_clear_baggage_basket_button.toLowerCase() === 'true') ||
    variants?.test_clear_baggage_basket_button === true;

  const canShowUpsellSummary = useMemo(() => {
    return basket.bags && Object.keys(basket.bags).length > 0;
  }, [basket]);

  const buttonStyles = getTriggerButtonStyles(theme, 'baggageTrigger');
  const sectionStyles = getTriggerStyles(theme, 'baggageTrigger');

  const title = getBaggageTriggerTitle(textOverrides);
  const titleContent = !!title ? (
    title
  ) : (
    <FormattedMessage id="baggage.title" defaultMessage="Baggage" />
  );

  return (
    <section
      className="gr-block sm:gr-flex gr-flex-col gr-box-border"
      style={sectionStyles}
    >
      <div className="gr-flex gr-flex-col sm:gr-flex-row gr-gap-4 gr-p-6">
        <div className="g-flex-1">
          <div className="gr-flex">
            <BaggageIcon scale={2} />
            <div className="gr-flex gr-flex-col gr-gap-4">
              <h3 className="gr-m-0 gr-ml-4 gr-text-primary gr-mt-1">
                {titleContent}
              </h3>
              <div className="gr-flex gr-flex-col gr-gap-1">
                <p className="gr-mx-4 gr-text-gray-600">
                  {hasBags ? (
                    <FormattedMessage
                      id="bags_load_success"
                      defaultMessage="Add Baggage"
                    />
                  ) : (
                    (textOverrides?.bags_load_failed ?? (
                      <FormattedMessage
                        id="bags_load_failed"
                        defaultMessage="Unable to load baggage options"
                      />
                    ))
                  )}
                </p>
                {availableBags && (
                  <span
                    className={
                      'gr-ml-4 gr-font-bold gr-text-base gr-text-gray-500'
                    }
                  >
                    <FormattedMessage
                      id="baggage.total_items"
                      defaultMessage="Total Items"
                    />
                    : {amountOfSelectedBags}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          id="gordian-bag-select-button-container"
          className="gr-flex-1 gr-flex gr-items-center sm:gr-justify-end gr-justify-center gr-w-full sm:gr-w-full  gr-overflow-auto"
        >
          {hasBags ? (
            <>
              {showRemoveButton ? (
                <button
                  onClick={() => {
                    setBaggageBasket({ bags: {} });
                    if (window.onBaggageBasketChange) {
                      window.onBaggageBasketChange([]);
                    }
                    setRemoveButtonClicked(true);
                    setTimeout(() => {
                      setRemoveButtonClicked(false);
                    }, 2000);
                  }}
                  disabled={!availableBags || removeButtonClicked}
                  id="gordian-remove-bag-selection"
                  className={`${
                    !removeButtonClicked
                      ? 'gr-bg-gray-400 gr-text-black'
                      : 'gr-bg-transparent'
                  } gr-text-center gr-border-0 gr-rounded-lg gr-mr-4`}
                  style={{
                    ...buttonStyles,
                    ...(removeButtonClicked && {
                      color: '#2990e6',
                    }),
                  }}
                >
                  {availableBags ? (
                    removeButtonClicked ? (
                      '✓ All Bags Removed'
                    ) : (
                      'Remove All Bags'
                    )
                  ) : (
                    <MoonLoader size={25} color={'white'} />
                  )}
                </button>
              ) : null}
              <button
                onClick={() => {
                  showModal(true);
                  setActiveWidget('baggage');
                }}
                disabled={!availableBags}
                id="gordian-bag-selection"
                className="gr-text-center"
                style={buttonStyles}
              >
                {availableBags ? (
                  <FormattedMessage id="add_bags" defaultMessage="Add Bags" />
                ) : (
                  <MoonLoader size={25} color={'white'} />
                )}
              </button>
            </>
          ) : null}
        </div>
      </div>
      {canShowUpsellSummary && <UpsellSummary trigger="baggage" />}
    </section>
  );
};

const mapStateToProps = (state) => ({
  flights: state.itinerary.flights,
  baggageData: state.baggageJSON.data,
  hasBags: state.session.hasBags,
  basket: parseAcceptedBags(state.basket, state.baggageJSON.data),
  variants: state.session.variants,
  theme: state.session.theme,
  textOverrides: state.session.textOverrides,
  // translations no longer needed with react-intl
});

const mapDispatchToProps = {
  showModal,
  setActiveWidget,
  setBaggageBasket,
  setBaggageData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Trigger);
